<template>
    <v-app id="app">
        <template v-if="loadingApp">
            <div class="loader-container">
                <div class="sk-cube-grid">
                    <div class="sk-cube sk-cube1"></div>
                    <div class="sk-cube sk-cube2"></div>
                    <div class="sk-cube sk-cube3"></div>
                    <div class="sk-cube sk-cube4"></div>
                    <div class="sk-cube sk-cube5"></div>
                    <div class="sk-cube sk-cube6"></div>
                    <div class="sk-cube sk-cube7"></div>
                    <div class="sk-cube sk-cube8"></div>
                    <div class="sk-cube sk-cube9"></div>
                </div>

                <div class="loader-text">
                    <p class="loading-message">Loading</p>
                </div>
            </div>
        </template>

        <template v-else>
            <loading></loading>
            <app-navigation-new v-if="isLoggedIn"></app-navigation-new>
            <dynamic-system-bar v-if="isLoggedIn" />
            <transition name="router-anim" enter-active-class="animated slideInRight">
                <v-main height="auto">
                    <router-view></router-view>
                </v-main>
            </transition>
            <Snackbar></Snackbar>
        </template>
    </v-app>
</template>

<script>
import $ from 'jquery';
import Snackbar from './components/Snackbar';
import AppNavigationNew from '@/components/AppNavigationNew';
import DynamicSystemBar from '@/components/Global/DynamicSystemBar.vue';
import Loading from '@/components/LoadingComponent';
import { mapGetters } from 'vuex';

export default {
    name: 'App',
    components: {
        Snackbar,
        AppNavigationNew,
        DynamicSystemBar,
        Loading
    },
    data() {
        return {
            dateRules: [
                v => !!v || 'This date is required',
                v =>
                    (parseInt(v[5] + v[6]) <= 12 &&
                        parseInt(v[5] + v[6]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[8] + v[9]) <= 31 &&
                        parseInt(v[8] + v[9]) > 0) ||
                    'Date Incorrect'
            ],
            dateTimeRules: [
                v => !!v || 'This DateTime is required',
                v =>
                    (parseInt(v[0] + v[1]) <= 12 &&
                        parseInt(v[0] + v[1]) > 0) ||
                    'Date Incorrect',
                v =>
                    (parseInt(v[3] + v[4]) <= 31 &&
                        parseInt(v[3] + v[4]) > 0) ||
                    'Date Incorrect',
                v => parseInt(v[6] + v[7]) <= 23 || 'Time Incorrect',
                v => parseInt(v[9] + v[10]) <= 59 || 'Time Incorrect'
            ]
        };
    },
    computed: {
        ...mapGetters('app', ['version', 'appTitle']),
        ...mapGetters('auth', ['isLoggedIn', 'loadingApp'])
    },
    methods: {
        contract(arr) {
            return arr.filter(el => el.getAttribute('id') !== null);
        },
        indexFind: function (arr) {
            var keyId;
            $(arr).each(function (idx, inpt) {
                if (inpt.id == document.activeElement.id) {
                    keyId = idx;
                }
            });
            if (arr.length == keyId + 1) {
                keyId = 0;
            } else {
                keyId++;
            }
            return keyId;
        }
    },
    watch: {
        isLoggedIn() {
            console.info('LoggedIn: ', this.isLoggedIn);
        }
    },
    mounted() {
        this.$store.state.dateRules = this.dateRules;
        this.$store.state.dateTimeRules = this.dateTimeRules;
        let options = JSON.parse(localStorage.getItem('userOptions'));
        if (options?.darkTheme == true) {
            this.$vuetify.theme.dark = true;
        }
    }
};
</script>

<style>
@import 'https://cdn.jsdelivr.net/npm/animate.css@3.5.1';
/* Dark Theme Styles */

.pm-0 {
    padding: 0 !important;
    margin: 0 !important;
}

.theme--dark {
    .v-data-table .v-data-table__wrapper table thead tr th {
        color: #eee;
        background: #607d8b;
    }

    .v-data-table .v-data-table__wrapper table tbody {
        tr:nth-of-type(odd) {
            background: #333;
        }

        tr:last-child td {
            background: #333;
        }
    }

    .v-expansion-panels .v-expansion-panel {
        color: #eee;
    }
}

/* Light Theme Styles */
.theme--light {
    .v-data-table .v-data-table__wrapper table thead tr th {
        color: #607d8b;
        background: #eee;
    }

    .v-expansion-panels .v-expansion-panel {
        color: #607d8b;
    }
}

tr th {
    background: #eee;
}

.v-data-table tbody tr:last-child td {
    position: unset !important;
}

html,
body,
#app,
.v-main {
    /* Make sure overflow is set to auto for scrolling */
    height: 100%;
    overflow-y: auto;
}

/* Webkit-based browsers (Chrome, Safari) */
::-webkit-scrollbar {
    width: 8px;
    /* Minimalist width */
}

::-webkit-scrollbar-thumb {
    background-color: rgba(100,
            100,
            100,
            0.4);
    /* Gray scroll bar with transparency */
    border-radius: 10px;
    /* Rounded corners */
}

::-webkit-scrollbar-thumb:hover {
    background-color: rgba(100, 100, 100, 0.6);
    /* Darker on hover */
}

::-webkit-scrollbar-track {
    background-color: rgba(0, 0, 0, 0.1);
    /* Track background */
    border-radius: 10px;
}

/* Firefox scrollbar */
* {
    scrollbar-width: thin;
    /* Minimalist width */
    scrollbar-color: rgba(100, 100, 100, 0.4) rgba(0, 0, 0, 0.1);
    /* Thumb and track colors */
}

/* Other global styles as needed */
body,
#app {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.loader-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #f5f5f5;
    font-size: 18px;
    color: #4f83cc;
    text-align: center;
    overflow: hidden;
}

.loader-text p {
    color: #4f83cc;
    font-size: 1.2rem;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    margin: 0;
    animation: fadeIn 2s infinite;
}

@keyframes fadeIn {

    0%,
    100% {
        opacity: 0;
    }

    50% {
        opacity: 1;
    }
}

.sk-cube-grid {
    width: 40px;
    height: 40px;
    margin: 100px auto 20px;
}

.sk-cube-grid .sk-cube {
    width: 33%;
    height: 33%;
    background-color: #4f83cc;
    float: left;
    -webkit-animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
    animation: sk-cubeGridScaleDelay 1.3s infinite ease-in-out;
}

.sk-cube-grid .sk-cube1 {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}

.sk-cube-grid .sk-cube2 {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
}

.sk-cube-grid .sk-cube3 {
    -webkit-animation-delay: 0.4s;
    animation-delay: 0.4s;
}

.sk-cube-grid .sk-cube4 {
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
}

.sk-cube-grid .sk-cube5 {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}

.sk-cube-grid .sk-cube6 {
    -webkit-animation-delay: 0.3s;
    animation-delay: 0.3s;
}

.sk-cube-grid .sk-cube7 {
    -webkit-animation-delay: 0s;
    animation-delay: 0s;
}

.sk-cube-grid .sk-cube8 {
    -webkit-animation-delay: 0.1s;
    animation-delay: 0.1s;
}

.sk-cube-grid .sk-cube9 {
    -webkit-animation-delay: 0.2s;
    animation-delay: 0.2s;
}

@-webkit-keyframes sk-cubeGridScaleDelay {

    0%,
    70%,
    100% {
        -webkit-transform: scale3D(1, 1, 1);
        transform: scale3D(1, 1, 1);
    }

    35% {
        -webkit-transform: scale3D(0, 0, 1);
        transform: scale3D(0, 0, 1);
    }
}

@keyframes sk-cubeGridScaleDelay {

    0%,
    70%,
    100% {
        -webkit-transform: scale3D(1, 1, 1);
        transform: scale3D(1, 1, 1);
    }

    35% {
        -webkit-transform: scale3D(0, 0, 1);
        transform: scale3D(0, 0, 1);
    }
}
</style>
